<template>
  <div>
    <div v-if="showCityFilter" class="shops_region_select">
      <div class="wrapper">
        <div class="row">
          <div class="large-6 medium-3 small-12 columns">
            <div class="your_region">
              <p class="your_region_header">{{ yourRegionTitle }}</p>
              <p class="your_city_header">{{ currentCityObject.name }}</p>
            </div>
          </div>
          <div class="large-3 medium-5 small-12 columns">
            <city-select :cities="cities" v-model="currentCity" />
          </div>
          <div class="large-3 medium-4 small-12 columns">
            <metro-select :metros="metros" v-if="metros.length" v-model="currentMetro" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showFullMap" class="select_shops_map">
      <shops-map :key="filteredShopsForMapKey" :shops="filteredShopsForMap" />
    </div>
    <div class="shops_list_block">
      <div class="wrapper">
        <div v-if="showFeatureFilter" class="checks">
          <div v-for="(feature, id) in cityFeatures" :key="'feature-' + id" class="mom">
            <input :checked="isChecked(id)" :id="'feature-' + id" type="checkbox" class="shop_type" name="shop_type[]" :value="id" @input="handleFeatureCheckbox" />
            <label :for="'feature-' + id">{{ feature }}</label>
          </div>
        </div>
        <div class="shop_list df fww">
          <shop v-for="(shop, index) in filteredShops"  :id="'shop-' + shop.id" v-bind="shop" @click.native.prevent="showShop(index)" >
            <a href="#" @click.prevent>{{ shopDetailsTitle }}</a>
          </shop>
        </div>
        <shop-detail ref="detail" v-bind="filteredShops[currentShop]" />
        <div class="dr-btn-wrapper" v-if="showInCatalogBtn">
          <a :href=showInCatalogUrl class="dr-btn dr-btn__brown_light">{{ showInCatalogBtnTitle }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Shop, ShopsMap } from "kanzler.components";
import ShopDetail from "./shop-detail.vue";
import CitySelect from "./city-select.vue";
import MetroSelect from "./metro-select.vue";

export default {
  props: {
    cities: {
      type: Array,
    },
    shops: {
      type: Array,
      required: true
    },
    defaultCity: {
      type: Number,
    },
    showCityFilter: {
      type: Boolean,
      default: true,
    },
    showFullMap: {
      type: Boolean,
      default: true,
    },
    showAllCities: {
      type: Boolean,
      default: false,
    },
    showFeatureFilter: {
      type: Boolean,
      default: true,
    },
    showInCatalogBtn: {
      type: Boolean,
      default: false,
    },
    showInCatalogUrl: {
      type: String,
      default: '#',
    },
  },
  data: () => {
    return {
      currentShop: null,
      currentMetro: '',

      selectedCity: undefined,
      selectedFeatures: [],
    }
  },
  components: {
    'shops-map': ShopsMap,
    'shop': Shop,
    'shop-detail': ShopDetail,
    'city-select': CitySelect,
    'metro-select': MetroSelect,
  },
  mounted() {
    this.popup = new Foundation.Reveal($(this.$refs['detail'].$el));
  },
  watch: {
      currentCity: function (newValue, oldValue) {
          if (newValue != oldValue) {
              this.currentMetro = ""
          }
      }
  },
  computed: {
    currentCity: {
      get() {
        return typeof this.selectedCity === "undefined"
            ? this.defaultCity
              ? this.defaultCity.toString()
              : null
            : this.selectedCity;
      },
      set(value) {
        this.selectedFeatures = [];
        this.selectedCity = value;
      },
    },
    currentCityObject() {
      return this.cities.find((city) => city.id === this.currentCity);
    },
    shopDetailsTitle() {
      return BX.message('KZ_SHOPS_DETAILS');
    },
    yourRegionTitle() {
      return BX.message('KZ_SHOPS_YOR_REGION');
    },
    showInCatalogBtnTitle() {
      return BX.message('KZ_SHOPS_IN_CATALOG_BTN');
    },
    shopsByCity() {
      return this.shops.filter(shop => !this.defaultCity || shop.cityId === this.currentCity);
    },
    cityFeatures() {
      return this.shopsByCity.reduce((accumulator, value) => {
        if (value.mapType !== null) {
          Object.keys(value.mapType).forEach((mapFeature) => {
            accumulator[mapFeature] = value.mapType[mapFeature];
          });
        }

        return accumulator;
      }, {});
    },
    filteredShops() {
      const cities = this.shopsByCity.sort((a, b) => a.name.localeCompare(b.name));

      return cities
        .filter(city => !this.currentMetro || (city.metroName && city.metroName === this.currentMetro))
        .filter(city => {
          if (this.selectedFeatures.length === 0) {
            return true;
          }

          if (!city.mapType) {
            return false;
          }

          return this.selectedFeatures.filter(feature => feature in city.mapType).length > 0;
        });
    },
    filteredShopsForMap() {
      return this.filteredShops.filter(shop => shop.coords !== null);
    },
    filteredShopsForMapKey() {
      return this.filteredShopsForMap.map(shop => shop.id).join(',');
    },
    metros() {
      const sortedMetroList = this.shopsByCity
          .map(shop => shop.metroName)
          .filter(Boolean)
          .sort((a,b) => a.localeCompare(b));

      return [...new Set(sortedMetroList)];
    }
  },
  methods: {
    showShop(index) {
      this.currentShop = index;
      this.popup.open();
    },
    handleFeatureCheckbox(event) {
      if (event.target.checked) {
        this.selectedFeatures.push(event.target.value);
      } else {
        this.selectedFeatures = this.selectedFeatures.filter(feature => feature !== event.target.value);
      }
    },
    isChecked(checkboxId) {
      return this.selectedFeatures.includes(checkboxId);
    }
  }
};
</script>
